module.exports = __webpack_public_path__ + "0f98065fb8cb744db49a2de9a8dcc852.png";